import script from "./TcAvatar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TcAvatar.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./TcAvatar.vue.scss?vue&type=style&index=0&id=adfe6d94&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcAvatar.vue?vue&type=style&index=0&id=adfe6d94&lang=scss"

const __exports__ = script;

export default __exports__